import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
  },
  eventsWrapper: {
    display: 'grid',
    'grid-template-columns': 'repeat(auto-fill,minmax(420px, 1fr))',
    'grid-gap': '1.75rem',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },

}))

export default useStyles
